export const universityList = [
    "A.P.J. ABDUL KALAM TECHNOLOGICAL UNIVERSITY, KERALA",
    "ACHARAYA NAGARJUNA UNIVERSITY, ANDHRA PRADESH",
    "AHMEDABAD UNIVERSITY, GUJARAT",
    "ALIGARH MUSLIM UNIVERSITY, UTTAR PRADESH",
    "ALLAHABAD STATE UNIVERSITY, UTTAR PRADESH",
    "ALLAHABAD UNIVERSITY, UTTAR PRADESH",
    "ALLIANCE UNIVERSITY, KARNATAKA",
    "AMITY UNIVERSITY, HARYANA",
    "AMITY UNIVERSITY, MADHYA PRADESH",
    "AMITY UNIVERSITY, MAHARASHTRA",
    "AMRITA VISHWA VIDYAPEETHAM, TAMIL NADU",
    "ANAND AGRICULTURAL UNIVERSITY, GUJARAT",
    "ANDHRA UNIVERSITY, ANDHRA PRADESH",
    "ANNA UNIVERSITY, TAMIL NADU",
    "ARYBHATTA KNOWLEDGE UNIVERSITY, BIHAR",
    "ATAL BIHARI VAJPAYEE INDIAN INSTITUTE OF INFORMATION TECHNOLOGY AND MANAGEMENT, MADHYA PRADESH",
    "BANASTHALI VIDYAPITH, RAJASTHAN",
    "BANGALORE UNIVERSITY, KARNATAKA",
    "BHARATI VIDYAPEETH, MAHARASHTRA",
    "BIJU PATNAIK UNIVERSITY OF TECHNOLOGY, ORISSA",
    "BIRLA GLOBAL UNIVERSITY, ORISSA",
    "BIRLA INSTITUTE OF TECHNOLOGY AND SCIENCE, RAJASTHAN",
    "BIRLA INSTITUTE OF TECHNOLOGY, JHARKHAND",
    "BML MUNJAL UNIVERSITY, HARYANA",
    "BUNDELKHAND UNIVERSITY, UTTAR PRADESH",
    "BURDWAN UNIVERSITY, WEST BENGAL",
    "CALCUTTA UNIVERSITY, WEST BENGAL",
    "CENTURION UNIVERSITY OF TECHNOLOGY AND MANAGEMENT, ORISSA",
    "CHANDIGARH UNIVERSITY, PUNJAB",
    "CHAROTAR UNIVERSITY OF SCIENCE AND TECHNOLOGY, GUJARAT",
    "CHATRAPATI SAHUJI MAHARAJ KANPUR UNIVERSITY, UTTAR PRADESH",
    "CHHATTISGARH SWAMI VIVEKANAND TECHNICAL UNIVERSITY, CHHATTISGARH",
    "CHITKARA UNIVERSITY, PUNJAB",
    "COCHIN UNIVERSITY OF SCIENCE AND TECHNOLOGY, KERALA",
    "DEEN BANDHU CHHOTU RAM UNIVERSITY OF SCIENCES AND TECHNOLOGY, HARYANA",
    "DELHI TECHNOLOGICAL UNIVERSITY, DELHI",
    "DELHI UNIVERSITY",
    "DEVI AHILYA VISHWAVIDYALAYA, MADHYA PRADESH",
    "DHARMSINH DESAI UNIVERSITY, GUJARAT",
    "DIBRUGARH UNIVERSITY, ASSAM",
    "DIT UNIVERSITY, UTTARAKHAND",
    "DR. A.P.J. ABDUL KALAM TECHNICAL UNIVERSITY, LUCKNOW",
    "DR. B. R. AMBEDKAR NATIONAL INSTITUTE OF TECHNOLOGY, JALANDHAR, PUNJAB",
    "DR. B.R. AMBEDKAR UNIVERSITY, UTTAR PRADESH",
    "DR. BABASAHEB AMBEDKAR MARATHWADA UNIVERSITY, MAHARASHTRA",
    "G.B. PANT UNIVERSITY OF AGRICULTURE AND TECHNOLOGY, UTTARAKHAND",
    "G.L.A UNIVERSITY, UTTAR PRADESH",
    "GALGOTIAS UNIVERSITY, UTTAR PRADESH",
    "GANDHI INSTITUTE OF TECHNOLOGY AND MANAGEMENT, ANDHRA PRADESH",
    "GAUTAM BUDDHA UNIVERSITY, UTTAR PRADESH",
    "GRAPHIC ERA HILL UNIVERSITY, UTTARAKHAND",
    "GRAPHIC ERA UNIVERSITY, UTTARAKHAND",
    "GUJARAT TECHNOLOGICAL UNIVERSITY, GUJARAT",
    "GULBARGA UNIVERSITY, KARNATAKA",
    "GURU GHASIDAS UNIVERSITY, CHHATTISGARH",
    "GURU GOBIND SINGH INDRAPRASTHA VISHWAVIDYALAYA, DELHI",
    "GURU NANAK DEV UNIVERSITY, PUNJAB",
    "GURUKUL KANGRI VISHWAVIDYALAYA, UTTARAKHAND",
    "HARCOURT BUTLER TECHNICAL UNIVERSITY, UTTAR PRADESH",
    "HIMACHAL PRADESH UNIVERSITY, HIMACHAL PRADESH",
    "IIT (BHU) VARANASI",
    "IIT (ISM) DHANBAD",
    "IIT BHILAI",
    "IIT BHUBANESWAR",
    "IIT BOMBAY",
    "IIT DELHI",
    "IIT DHARWAD",
    "IIT GANDHINAGAR",
    "IIT GOA",
    "IIT GUWAHATI",
    "IIT HYDERABAD",
    "IIT INDORE",
    "IIT JAMMU",
    "IIT JODHPUR",
    "IIT KANPUR",
    "IIT KHARAGPUR",
    "IIT MADRAS",
    "IIT MANDI",
    "IIT PALAKKAD",
    "IIT PATNA",
    "IIT ROORKEE",
    "IIT ROPAR",
    "IIT TIRUPATI",
    "INDIAN INSTITUTE OF MANAGEMENT, AHMEDABAD",
    "INDIAN INSTITUTE OF MANAGEMENT, KASHIPUR",
    "INDIAN INSTITUTE OF MANAGEMENT, RAIPUR",
    "INDIAN INSTITUTE OF MANAGEMENT, RANCHI",
    "INDIAN INSTITUTE OF MANAGEMENT, ROHTAK",
    "INDIAN INSTITUTE OF MANAGEMENT, SHILLONG",
    "INDIAN INSTITUTE OF MANAGEMENT, SIRMAUR",
    "INDRAPRASTHA INSTITUTE OF INFORMATION TECHNOLOGY, DELHI",
    "INDUS UNIVERSITY, GUJARAT",
    "INSTITUTE OF INFRASTRUCTURE TECHNOLOGY RESEARCH AND MANAGEMENT, GUJARAT",
    "INTERNATIONAL INSTITUTE OF INFORMATION TECHNOLOGY",
    "INTERNATIONAL INSTITUTE OF INFORMATION TECHNOLOGY, ORISSA",
    "J.E.C.R.C UNIVERSITY, RAJASTHAN",
    "J.K. LAKSHMIPAT UNIVERSITY, RAJASTHAN",
    "JADAVPUR UNIVERSITY, WEST BENGAL",
    "JAGADGURU SRI SHIVARATHREESHWARA UNIVERSITY, KARNATAKA",
    "JAI NARAIN VYAS UNIVERSITY, RAJASTHAN",
    "JAIN UNIVERSITY, KARNATAKA",
    "JAMIA MILLIA ISLAMIA, DELHI",
    "JAMMU UNIVERSITY, JAMMU AND KASHMIR",
    "JAWAHARLAL NEHRU TECHNOLOGICAL UNIVERSITY, ANDHRA PRADESH",
    "JAWAHARLAL NEHRU TECHNOLOGICAL UNIVERSITY, TELANGANA",
    "JAYPEE INSTITUTE OF INFORMATION TECHNOLOGY UNIVERSITY, UTTAR PRADESH",
    "JAYPEE UNIVERSITY OF ENGINEERING AND TECHNOLOGY, MADHYA PRADESH",
    "JAYPEE UNIVERSITY OF INFORMATION TECHNOLOGY, HIMACHAL PRADESH",
    "JHARKHAND RAI UNIVERSITY, JHARKHAND",
    "KADI SARVA VISHWAVIDYALAYA, GUJARAT",
    "KAKATIYA UNIVERSITY, TELANGANA",
    "KALINGA INSTITUTE OF INDUSTRIAL TECHNOLOGY, ORISSA",
    "KERALA UNIVERSITY",
    "KIIT UNIVERSITY",
    "KLE TECHNOLOGICAL UNIVERSITY",
    "KURUKSHETRA UNIVERSITY",
    "LALIT NARAYAN MITHILA UNIVERSITY",
    "LNM INSTITUTE OF INFORMATION TECHNOLOGY",
    "LOVELY PROFESSIONAL UNIVERSITY",
    "M.J.P. ROHILKHAND UNIVERSITY",
    "M.S. RAMAIAH UNIVERSITY OF APPLIED SCIENCES",
    "MADAN MOHAN MALAVIYA UNIVERSITY OF TECHNOLOGY",
    "MAHARAJA RANJIT SINGH PUNJAB TECHNICAL UNIVERSITY",
    "MAHARAJA SAYAJIRAO UNIVERSITY OF BARODA",
    "MAHARISHI DAYANAND UNIVERSITY",
    "MANIPAL UNIVERSITY",
    "MAULANA ABUL KALAM AZAD UNIVERSITY OF TECHNOLOGY",
    "MOTILAL NEHRU NATIONAL INSTITUTE OF TECHNOLOGY, ALLAHABAD",
    "MUMBAI UNIVERSITY",
    "NARSEE MONJEE INSTITUTE OF MANAGEMENT STUDIES",
    "NATIONAL INSTITUTE OF TECHNOLOGY KARNATAKA, SURATHKAL",
    "NATIONAL INSTITUTE OF TECHNOLOGY, CALICUT",
    "NATIONAL INSTITUTE OF TECHNOLOGY, DURGAPUR",
    "NATIONAL INSTITUTE OF TECHNOLOGY, HAMIRPUR",
    "NATIONAL INSTITUTE OF TECHNOLOGY, JAMSHEDPUR",
    "NATIONAL INSTITUTE OF TECHNOLOGY, KURUKSHETRA",
    "NATIONAL INSTITUTE OF TECHNOLOGY, MANIPUR",
    "NATIONAL INSTITUTE OF TECHNOLOGY, PATNA",
    "NATIONAL INSTITUTE OF TECHNOLOGY, RAIPUR",
    "NATIONAL INSTITUTE OF TECHNOLOGY, ROURKELA",
    "NATIONAL INSTITUTE OF TECHNOLOGY, SILCHAR",
    "NATIONAL INSTITUTE OF TECHNOLOGY, SRINAGAR",
    "NIRMA UNIVERSITY",
    "OSMANIA UNIVERSITY",
    "PEC UNIVERSITY OF TECHNOLOGY",
    "PES UNIVERSITY",
    "PUNJAB TECHNICAL UNIVERSITY",
    "PUNJAB UNIVERSITY",
    "RAJASTHAN TECHNICAL UNIVERSITY",
    "RAJIV GANDHI PROUDYOGIKI VISHWAVIDYALAYA",
    "REVA UNIVERSITY",
    "SAMBALPUR UNIVERSITY",
    "SASTRA DEEMED UNIVERSITY, TAMIL NADU",
    "SATHYABAMA UNIVERSITY",
    "SAVITRIBAI PHULE PUNE UNIVERSITY",
    "SHIVAJI UNIVERSITY",
    "SHRI MATA VAISHNO DEVI UNIVERSITY, JAMMU AND KASHMIR",
    "SIKSHA O ANUSANDHAN, ORISSA",
    "SOLAPUR UNIVERSITY, MAHARASHTRA",
    "SRI VENKATESWARA UNIVERSITY, ANDHRA PRADESH",
    "SRM UNIVERSITY, TAMIL NADU",
    "SYMBIOSIS INTERNATIONAL UNIVERSITY, MAHARASHTRA",
    "TECHNO INDIA UNIVERSITY, WEST BENGAL",
    "TEZPUR UNIVERSITY, ASSAM",
    "THAPAR UNIVERSITY, PUNJAB",
    "UNIVERSITY OF DELHI, DELHI",
    "UNIVERSITY OF ENGINEERING AND MANAGEMENT, WEST BENGAL",
    "UNIVERSITY OF JAMMU",
    "UNIVERSITY OF PETROLEUM AND ENERGY STUDIES, UTTARAKHAND",
    "UTTARAKHAND TECHNICAL UNIVERSITY, UTTARAKHAND",
    "VEER SURENDRA SAI UNIVERSITY OF TECHNOLOGY, ORISSA",
    "VISVESVARAYA TECHNOLOGICAL UNIVERSITY, BELAGAVI",
    "VISVESVARAYA NATIONAL INSTITUTE OF TECHNOLOGY, NAGPUR",
    "VIT UNIVERSITY, TAMIL NADU",
    "YMCA UNIVERSITY OF SCIENCE AND TECHNOLOGY, HARYANA"
]